var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import moment from 'moment';
import { checkName, checkInteger } from '../../utils/common-utils';
import { COMMONGIFTURL, CONTACTTEMPLATE } from '../../constant/common-gift';
import cookie from '../../cookie/cookie';
import searchSelectAdd from '../../components/console-common/search-select-add.vue';
import selfTextarea from '../../components/console-common/common-textarea.vue';
export default Vue.extend({
    name: 'login',
    components: {
        'el-self-textarea': selfTextarea,
        'el-search-select-add': searchSelectAdd,
    },
    computed: __assign({}, mapState('info', {
        cityList: 'cityList',
        signCompanyList: 'signCompanyList',
        settleCompanyList: 'settleCompanyList',
    }), { contractTemplate: function () {
            return COMMONGIFTURL + CONTACTTEMPLATE;
        } }),
    data: function () {
        var _this = this;
        var phoneValidate = function (rule, value, callback) {
            // /^\s*[1]{1}[0-9]{10}\s*$/
            //  /^\s*[0-9]{1}[0-9]{10}\s*$/
            var re = /^\s*[0-9]{1}[0-9]{10}\s*$/;
            // const re = /^\s*[1]{1}[0-9]{10}\s*$/
            if (!value) {
                return callback(new Error('请输入司机在滴滴注册的手机号'));
            }
            else if (value && !re.test(value)) {
                return callback(new Error('手机号格式不正确'));
            }
            else {
                callback();
            }
        };
        var checkDriverIdNo = function (rule, value, callback) {
            var re = /^\s*\d{17}\S{1}\s*$/;
            if (!value) {
                return callback(new Error('请输入司机身份证号'));
            }
            else if (!re.test(value)) {
                return callback(new Error('请输入正确的身份证号码'));
            }
            else {
                callback();
            }
        };
        var isvalidatecontractTime = function (rule, value, callback) {
            if (value[0] == null ||
                value[0] == undefined ||
                value[1] == null ||
                value[1] == undefined) {
                return callback(new Error('请选择有效期'));
            }
            else {
                if (Date.parse(value[0]) > Date.parse(value[1]) ||
                    Date.parse(value[0]) === Date.parse(value[1])) {
                    return callback(new Error('开始时间必须小于结束时间'));
                }
                else {
                    callback();
                }
            }
        };
        var checkContract = function (rule, value, callback) {
            var reg = /^[\u4e00-\u9fa5_a-zA-Z0-9\-\[\]\(\)\（\）]+$/;
            var len = value.length;
            if (!value) {
                return callback(new Error('请输入合同号'));
            }
            else if (!reg.test(value)) {
                return callback(new Error('合同号只能包含数字、字母、下划线、中划线、小括号、中括号、中文,'));
            }
            else if (len > 24) {
                return callback(new Error('合同号最多24位'));
            }
            else {
                callback();
            }
        };
        var checkIsNumber = function (rule, value, callback) {
            var res = /^\s*(\d{1,6}|\d{1,6}[.]{1}[0-9]{1,2})\s*$/;
            if (!value) {
                return callback(new Error('请输入数字'));
            }
            else if (!res.test(value)) {
                return callback(new Error('请输入数字，整数部分最多6位，小数部分最多2位'));
            }
            else {
                callback();
            }
        };
        var checkIsNumber1 = function (rule, value, callback) {
            var res = /^\s*(\d{1,6}|\d{1,6}[.]{1}[0-9]{1,2})\s*$/;
            var name = rule.name;
            var types = rule.types;
            if (value) {
                if (!res.test(value)) {
                    return callback(new Error('请输入数字，整数部分最多6位，小数部分最多2位'));
                }
                return callback();
            }
            else {
                callback();
                name ? _this.$refs[name].clearValidate() : '';
            }
        };
        var lengthLimit = function (rule, value, callback) {
            var reg = RegExp("^\\S{1," + rule.max + "}$");
            if (!reg.test(value)) {
                return callback(new Error("\u6700\u591A" + rule.max + "\u4E2A\u5B57\u7B26"));
            }
            callback();
        };
        var checkName_ = function (rule, value, callback) {
            var reg = /^[u4e00-u9fa5\s,a-zA-Z,0-9]{2,50}$/;
            if (!reg.test(value)) {
                return callback(new Error('只能输入中文，数字，英文，空格，且字符范围2-50'));
            }
            callback();
        };
        return {
            isShowContractTemplate: false,
            ruleForm: {
                contractTime: [],
                repaymentTime: [],
                leaseMode: 'JINGZU',
                totalAmount: '',
                monthlyPayment: '',
                totalDuration: '',
            },
            add: true,
            usernameZh: '',
            cityName: '',
            Isdisabled: true,
            isDisabledDriverMsg: false,
            // isDisabledLeaseMode: false,
            rules: {
                contractCode: [
                    { required: true, message: '请输入合同号', trigger: 'blur' },
                    { required: true, validator: checkContract, trigger: 'blur' },
                ],
                cityCode: [
                    { required: true, message: '请选择城市', trigger: 'change' },
                ],
                driverName: [
                    { required: true, message: '请输入司机姓名', trigger: 'blur' },
                    { required: true, validator: checkName, trigger: 'blur' },
                ],
                driverIdNo: [
                    { required: true, message: '请输入司机身份证号', trigger: 'blur' },
                    { validator: checkDriverIdNo, trigger: 'blur' },
                ],
                driverContact: [
                    {
                        required: true,
                        message: '请输入司机的联系方式',
                        trigger: 'blur',
                        min: 1,
                        max: 50,
                    },
                ],
                driverMobile: [
                    {
                        required: true,
                        message: '请输入司机在滴滴注册的手机号',
                        trigger: 'blur',
                    },
                    { validator: phoneValidate, trigger: 'blur' },
                ],
                plateNumber: [
                    { required: true, message: '请输入车牌号', trigger: 'blur' },
                    {
                        pattern: /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5,6}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4,5})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳使领]))$/,
                        message: '车牌号格式不正确',
                        trigger: 'blur',
                    },
                ],
                contractTime: [
                    {
                        required: true,
                        validator: isvalidatecontractTime,
                        trigger: 'change',
                    },
                ],
                repaymentTime: [
                    {
                        required: true,
                        validator: isvalidatecontractTime,
                        trigger: 'change',
                    },
                ],
                leaseMode: [
                    { required: true, message: '请选择业务模式', trigger: 'change' },
                ],
                capCityName: [
                    { required: true, message: '城市不能为空', trigger: 'blur' },
                ],
                capCompanyName: [
                    { required: true, message: '公司名称不能为空', trigger: 'blur' },
                ],
                totalAmount: [
                    { required: true, message: '金额不能为空', trigger: 'blur' },
                    { required: true, validator: checkIsNumber1, trigger: 'blur' },
                ],
                totalDuration: [
                    { required: true, message: '请输入整数', trigger: 'blur' },
                    { required: true, validator: checkInteger, trigger: 'blur' },
                ],
                monthlyPayment: [
                    { required: true, message: '金额不能为空', trigger: 'blur' },
                    { required: true, validator: checkIsNumber, trigger: 'blur' },
                ],
                guaranteeDeposit: [
                    {
                        required: false,
                        validator: checkIsNumber1,
                        name: 'guaranteeDeposit',
                        trigger: 'blur',
                    },
                ],
                tailPayment: [
                    {
                        required: false,
                        validator: checkIsNumber1,
                        name: 'tailPayment',
                        trigger: 'blur',
                    },
                ],
                downPayment: [
                    {
                        required: false,
                        validator: checkIsNumber1,
                        name: 'downPayment',
                        trigger: 'blur',
                    },
                ],
                transactorContract: [
                    {
                        required: false,
                        validator: checkName,
                        trigger: 'blur',
                        name: 'transactorContract',
                        tips: '合同经办人',
                    },
                ],
                transactorSale: [
                    {
                        required: false,
                        validator: checkName,
                        trigger: 'blur',
                        name: 'transactorSale',
                        tips: '销售',
                    },
                ],
                transactorManager: [
                    {
                        required: false,
                        validator: checkName,
                        trigger: 'blur',
                        name: 'transactorManager',
                        tips: '司管',
                    },
                ],
                companyName: [
                    { required: false, validator: checkName_, trigger: 'blur' },
                ],
                signStatus: [
                    { required: true, message: '请选择协议状态', trigger: 'blur' },
                ],
            },
        };
    },
    created: function () {
        this.getUserName();
        this.$store.dispatch('info/GET_COMPANY_ALL', { type: 'SIGN' });
        this.$store.dispatch('info/GET_COMPANY_ALL', { type: 'SETTLEMENT' });
    },
    methods: {
        formatterNum: function (value) {
            var valArr = (value + '').split('.');
            if (valArr.length === 1) {
                return Number(valArr[0] + '00');
            }
            if (valArr[1].length == 1) {
                return Number(valArr[0] + '' + valArr[1] + '0');
            }
            return valArr[0] + valArr[1];
        },
        autoTotalAmount: function () {
            var _monthlyPayment = this.ruleForm.monthlyPayment;
            var _totalDuration = this.ruleForm.totalDuration;
            var totalAmount = Number.parseFloat(_monthlyPayment) * Number.parseFloat(_totalDuration);
            if (isNaN(totalAmount)) {
                this.ruleForm.totalAmount = '';
                return;
            }
            this.ruleForm.totalAmount = totalAmount.toFixed(2);
        },
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        isEmpty: function (flag) {
            if (flag == 0) {
                this.cityHidden = this.cityName == '' ? 'inherit' : 'hidden';
                this.cityBorder = this.cityName == '' ? true : false;
            }
            else {
                this.comHidden = this.companyName == '' ? 'inherit' : 'hidden';
                this.comBorder = this.companyName == '' ? true : false;
            }
            this.Isdisabled = !(this.companyName != '' && this.cityName != '');
        },
        addCompany: function () {
            this.add = false;
        },
        cancelAdd: function () {
            this.cityHidden = 'hidden';
            this.comHidden = 'hidden';
            this.cityBorder = false;
            this.comBorder = false;
            this.Isdisabled = true;
            this.add = true;
            this.companyName = '';
            this.cityName = '';
        },
        cityChange: function (val) {
            for (var _i = 0, _a = this.cityList; _i < _a.length; _i++) {
                var temp = _a[_i];
                if (temp.cityCode === val) {
                    this.ruleForm.cityName = temp.cityName;
                }
            }
        },
        getDriverMsg: function () {
            var _this = this;
            var driverIdNo = this.ruleForm.driverIdNo;
            this.$refs['ruleForm'].validateField('driverIdNo', function (errorMsg) {
                if (errorMsg !== '')
                    return false;
                _this.$request({
                    url: 'proxy/api/driver/briefInfo/idNo',
                    method: 'post',
                    data: {
                        creator: _this.usernameZh,
                        driverIdNo: driverIdNo,
                    },
                }).then(function (res) {
                    if (!res || res.errorCode)
                        return;
                    var flag = _this.isDisabledDriverMsg;
                    _this.isDisabledDriverMsg = false;
                    var data = res.data;
                    if (!data) {
                        if (flag) {
                            _this.ruleForm = Object.assign(_this.ruleForm, {
                                driverContact: '',
                                driverName: '',
                                driverMobile: '',
                            });
                        }
                        return;
                    }
                    var contact = data.contact, driverName = data.driverName, mobile = data.mobile;
                    _this.ruleForm = Object.assign(_this.ruleForm, {
                        driverContact: contact,
                        driverName: driverName,
                        driverMobile: mobile,
                    });
                    _this.$refs['ruleForm'].clearValidate([
                        'driverContact',
                        'driverName',
                        'driverMobile',
                    ]);
                    _this.isDisabledDriverMsg = true;
                });
            });
        },
        getLeaseMode: function () {
            var _this = this;
            var plateNumber = this.ruleForm.plateNumber;
            this.$refs['ruleForm'].validateField('plateNumber', function (errorMsg) {
                if (errorMsg !== '')
                    return false;
                _this.$request({
                    url: '/proxy/vehicle/driver/vehicle/briefInfo/plateNumber',
                    method: 'post',
                    data: {
                        creator: _this.usernameZh,
                        plateNumber: plateNumber,
                    },
                }).then(function (res) {
                    if (!res || res.errorCode) {
                        return;
                    }
                    var data = res.data;
                    if (!data || data.purpose === 'OTHER') {
                        _this.ruleForm = Object.assign(_this.ruleForm, {
                            leaseMode: 'JINGZU',
                        });
                        // this.isDisabledLeaseMode = false
                        return;
                    }
                    _this.ruleForm = Object.assign(_this.ruleForm, {
                        leaseMode: data.purpose,
                    });
                    // this.isDisabledLeaseMode = true
                });
            });
        },
        sureAdd: function (type) {
            var _this = this;
            this.$request({
                method: 'post',
                url: '/proxy/api/company/add',
                data: {
                    type: type,
                    name: this.companyName,
                    creator: this.usernameZh,
                    // tenant:this.merchantId,
                    cityName: this.cityName,
                },
            }).then(function (res) {
                if (!res) {
                    _this.add = true;
                    _this.companyName = '';
                    _this.cityName = '';
                    return;
                }
                if (!res.errorCode) {
                    _this.$store.dispatch('info/GET_COMPANY_ALL', { type: type });
                    _this.add = true;
                    _this.companyName = '';
                    _this.cityName = '';
                }
            });
        },
        submitForm: function (formName) {
            var _this = this;
            this.$refs[formName].validate(function (valid) {
                if (!valid)
                    return;
                var repaymentTime = _this.ruleForm.repaymentTime;
                var contractTime = _this.ruleForm.contractTime;
                var repayStartArr = new Date(repaymentTime[0]).getTime();
                var repayEndArr = new Date(repaymentTime[1]).getTime();
                var conStartArr = new Date(contractTime[0]).getTime();
                var conEndArr = new Date(contractTime[1]).getTime();
                var repayValue = repayEndArr - repayStartArr;
                var conValue = conEndArr - conStartArr;
                if (conValue !== repayValue) {
                    _this.$message.error('合同有效期和还款有效期的时间间隔需一致');
                    return;
                }
                function submitMation(that) {
                    // 提交表单
                    var data = Object.assign({}, that.ruleForm);
                    data.creator = that.usernameZh;
                    // data.tenant = this.merchantId
                    var totalAmount = data.totalAmount;
                    var monthlyPayment = data.monthlyPayment;
                    var guaranteeDeposit = data.guaranteeDeposit;
                    var downPayment = data.downPayment;
                    var tailPayment = data.tailPayment;
                    data.totalAmount =
                        totalAmount == 0 || totalAmount
                            ? that.formatterNum(totalAmount)
                            : '';
                    data.monthlyPayment =
                        monthlyPayment == 0 || monthlyPayment
                            ? that.formatterNum(monthlyPayment)
                            : '';
                    data.guaranteeDeposit = guaranteeDeposit
                        ? that.formatterNum(guaranteeDeposit)
                        : '';
                    data.downPayment = downPayment ? that.formatterNum(downPayment) : '';
                    data.tailPayment = tailPayment ? that.formatterNum(tailPayment) : '';
                    that
                        .$request({
                        method: 'post',
                        url: '/proxy/api/contract/add',
                        data: data,
                    })
                        .then(function (res) {
                        if (!res)
                            return;
                        // res = {errorCode: 0}
                        if (res.errorCode) {
                            that
                                .$alert('', '', {
                                message: "<p class=\"title\">\u5408\u540C\u5BFC\u5165\u51FA\u9519\u4E86</p><p class=\"text\">" + res.errorMsg + "</p>",
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: '知道了',
                                type: 'error',
                                showClose: false,
                            })
                                .then(function () {
                                // this.ruleForm = {}
                            });
                        }
                        if (!res.errorCode) {
                            that
                                .$confirm('', '', {
                                message: '<p class="title">合同导入成功</p><p class="text">可前往合同管理-合同查询查看</p>',
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: '合同查询',
                                cancelButtonText: '好的',
                                type: 'warning',
                                showClose: false,
                            })
                                .then(function () {
                                that.$router.push({
                                    path: '/console/contract/query',
                                });
                                that.ruleForm = {};
                            })
                                .catch(function () {
                                that.ruleForm.note = '';
                                that.ruleForm.totalAmount = '';
                                that.$refs[formName].resetFields();
                                that.isDisabledDriverMsg = false;
                                // that.isDisabledLeaseMode = false
                            });
                        }
                    });
                }
                function validateCompany(that) {
                    // 验证是否创建过合同
                    that
                        .$request({
                        method: 'post',
                        url: '/proxy/api/contract/driver/idNo/exists',
                        data: {
                            driverIdNo: that.ruleForm.driverIdNo,
                        },
                    })
                        .then(function (res) {
                        if (!res || res.errorCode) {
                            return;
                        }
                        if (res.data) {
                            that
                                .$confirm('', '', {
                                message: "<p class=\"title\">\u63D0\u793A</p><p class=\"text\">\u8BE5\u53F8\u673A\u76EE\u524D\u5DF2\u6709\u4E00\u4E2A\u4F7F\u7528\u4E2D\u7684\u5408\u540C, \u662F\u5426\u7EE7\u7EED\u521B\u5EFA\u65B0\u5408\u540C?</p>",
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: '继续创建',
                                cancelButtonText: '取消',
                                type: 'warning',
                                showClose: false,
                            })
                                .then(function () {
                                submitMation(that);
                            })
                                .catch(function () { });
                            return;
                        }
                        submitMation(that);
                    });
                }
                _this.$request({
                    method: 'post',
                    url: '/proxy/api/contract/driver/signCompany/match',
                    data: {
                        driverMobile: _this.ruleForm.driverMobile,
                    },
                }).then(function (res) {
                    if (!res) {
                        _this.$message.error('系统错误');
                        return;
                    }
                    if (res.errorCode) {
                        return;
                    }
                    if (res.data) {
                        validateCompany(_this);
                        return;
                    }
                    _this.$message.error('该司机在滴滴系统中归属于其他公司');
                });
            });
        },
        resetForm: function (formName) {
            this.$refs[formName].resetFields();
        },
        clearForm: function (formName) {
            this.ruleForm.totalAmount = '';
            this.ruleForm.totalDuration = '';
            this.ruleForm.monthlyPayment = '';
            this.ruleForm.guaranteeDeposit = '';
            this.ruleForm.downPayment = '';
            this.ruleForm.tailPayment = '';
        },
        formatDate: function (time, formTime, index, flag) {
            if (this['ruleForm'][time] !== null &&
                this['ruleForm'][time] !== undefined) {
                this['ruleForm'][formTime] = moment(this['ruleForm'][time][index]).format('YYYY-MM-DD');
            }
            var contractTimeStart = this['ruleForm']['contractTime'][0];
            var contractTimeEnd = this['ruleForm']['contractTime'][1];
            var repaymentTimeStart = this['ruleForm']['repaymentTime'][0];
            if (flag == 'auto') {
                if (contractTimeStart != null &&
                    contractTimeStart != undefined &&
                    (contractTimeEnd != null && contractTimeEnd != undefined) &&
                    (repaymentTimeStart != null && repaymentTimeStart != undefined)) {
                    var repaymentTimeEnd = new Date(contractTimeEnd.getTime() -
                        contractTimeStart.getTime() +
                        repaymentTimeStart.getTime());
                    if (this['ruleForm']['repaymentTime'].length > 1) {
                        this['ruleForm']['repaymentTime'].pop();
                    }
                    this['ruleForm']['repaymentTime'].push(repaymentTimeEnd);
                    this['ruleForm']['repayEndTime'] = moment(repaymentTimeEnd).format('YYYY-MM-DD');
                }
            }
        },
    },
});
